export class Country {
  countryId: string;
  countryCode: string;
  regionId: string;
  deleted: number;
  name: string;

  constructor(params: CountryParams) {
    this, (this.countryId = params.countryId);
    this.countryCode = params.countryCode;
    this.regionId = params.regionId;
    this.deleted = params.deleted;
    this.name = params.name;
  }
}

interface CountryParams {
  countryId: string;
  countryCode: string;
  regionId: string;
  deleted: number;
  name: string;
}
